
import React, { useState } from 'react';
import { Typography, Button, Modal, Box, TextField, Divider, FormControlLabel, Checkbox } from '@mui/material';
import CloudUpload from '@mui/icons-material/CloudUpload';

export default function GithubBearerSetup({ handleNext, handleBack, githubBearer, setGithubBearer, handleSendSettings, isConnected, handleRestart }) {
  const [open, setOpen] = useState(false);
  const [isShowGithubBearer, setIsShowGithubBearer] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleFinishButton = () => {
    handleNext()
    handleSendSettings()
  }

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    textAlign: 'center',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '1px solid #000',
    boxShadow: 24,
    p: 2,
  };

  return (
    <div>
      <Typography variant="h6" gutterBottom>
        GitHub Token 설정
      </Typography>
      <TextField
        label="Bearer Token"
        variant="outlined"
        fullWidth
        type={isShowGithubBearer?"text":"password"}
        value={githubBearer}
        onChange={(e) => setGithubBearer(e.target.value)}
        style={{ marginBottom: '16px' }}
      />
      <FormControlLabel control={
        <Checkbox
          checked={isShowGithubBearer}
          onChange={(e) => setIsShowGithubBearer(e.target.checked)}
        />
        }
        label="Github Token 보기"
      />
      <Divider style={{ margin: '12px 0 12px 0' }} />
      { isConnected ? (
        <>
          <Button
            variant="contained"
            color="primary"
            onClick={handleOpen}
            style={{ float: 'right' }}
          >
            설정 저장
          </Button>
          <Button
            variant="outlined"
            color="secondary"
            onClick={handleBack}
            style={{ float: 'right', margin: '0 8px' }}
          >
            이전
          </Button>
        </>
      ) : (
        <Button
          variant="contained"
          color="secondary"
          onClick={handleRestart}
          style={{ float: 'right', margin: '0 8px' }}
        >
          처음으로
        </Button>
      )}

      <Modal open={open} onClose={handleClose}>
        <Box sx={style}>
          <CloudUpload style={{ fontSize: 100, color: '#4dabf5' }} />
          <Typography variant="h6" style={{ marginTop: '8px', marginBottom: '8px' }}>
            설정을 저장하시겠습니까?
          </Typography>
          <Button
            variant="outlined"
            color="secondary"
            onClick={handleClose}
            style={{ float: 'right', margin: '0 8px' }}
          >
            아니오
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleFinishButton}
            style={{ float: 'right' }}
          >
            예
          </Button>
        </Box>
      </Modal>
    </div>
  );
}
